/* eslint-disable no-undef */
import React from 'react'
import ReactDOM from 'react-dom/client'
import '@/utils/rem'
import { Provider } from 'react-redux'
import { checkIOS, checkPC, setCommonStore } from '@/utils/getPreInfo'
import VConsole from 'vconsole'
import reportWebVitals from './reportWebVitals'
import App from './App'
import store from './store'
import '@/assets/css/reset.css'
import '@/assets/css/base.css'

if (process.env.REACT_APP_ENV !== 'prod') {
  // eslint-disable-next-line no-unused-vars
  const vConsole = new VConsole()
}

// 环境判断
checkIOS()
// 设备样式判断
checkPC()
const initAppInfo = async () => {
  // store示例-前置查询之类
  setCommonStore()
  const root = ReactDOM.createRoot(document.getElementById('root'))
  root.render(
    // <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
    // </React.StrictMode>
  )
}

initAppInfo()

reportWebVitals()
